var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"hero-slider swiper-container"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.slides),function(slide){return _c('div',{staticClass:"swiper-slide"},[_c(slide,{tag:"component"})],1)}),0),_vm._v(" "),_c('div',{staticClass:"swiper-button-prev swiper-button-white"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-next swiper-button-white"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ca158bc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./theme/bananar/Bananar.vue
// module id = 194
// module chunks = 0 1